import React from "react";
import { Breadcrumb, Button, Tooltip } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { hasPermission, privilegesEnum } from "../../helpers/PermissionHelper";
import styles from "./PageHeader.module.scss";

interface PageHeaderProps {
  title: string;
  icon: React.ReactNode;
  onCreateClick?: () => void;
  createButtonText?: string;
  createButtonIcon?: React.ReactNode;
  createPermission?: keyof typeof privilegesEnum;
  showCreateButton?: boolean;
  additionalButtons?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  icon,
  onCreateClick,
  createButtonText = "Common-CreateNew",
  createButtonIcon = <PlusOutlined />,
  createPermission = privilegesEnum.WRITE_CLIENTS,
  showCreateButton = true,
  additionalButtons,
}) => {
  const { t } = useTranslation();
  return (
    <div className={styles.header}>
      <div>
        <Breadcrumb className={styles.breadcrumb}>
          <Breadcrumb.Item>
            <span className={styles.currentPage}>
              {icon}
              <span>{title}</span>
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>
      </div>
      <div className={styles.actionButtonsWrapper}>
        {showCreateButton && hasPermission(createPermission) && (
          <Tooltip title={t(createButtonText)}>
            <Button
              onClick={onCreateClick}
              className={styles.newButton}
              type="primary"
              icon={createButtonIcon}
            />
          </Tooltip>
        )}
        {additionalButtons}
      </div>
    </div>
  );
};

export default PageHeader;
